import { IClientEnvironment } from "../_common/interface/quoteConversionAudit/iClientEnvironment.interface";

export function getClientEnvironment(): IClientEnvironment {
    const ua = navigator.userAgent;

    let deviceType = "desktop";
    if (/ipad|tablet/i.test(ua)) {
        deviceType = "tablet";
    } else if (/mobi|iphone|android/i.test(ua)) {
        deviceType = "mobile";
    }

    let operatingSystem = "unknown";
    if (/android/i.test(ua)) {
        operatingSystem = "Android";
    } else if (/iphone|ipad|ipod/i.test(ua)) {
        operatingSystem = "iOS";
    } else if (/win/i.test(ua)) {
        operatingSystem = "Windows";
    } else if (/mac/i.test(ua)) {
        operatingSystem = "Mac";
    } else if (/linux/i.test(ua)) {
        operatingSystem = "Linux";
    }

    let browser = "unknown";
    if (/edg/i.test(ua)) {
        browser = "Edge";
    } else if (/firefox/i.test(ua)) {
        browser = "Firefox";
    } else if (/chrome/i.test(ua) && !/edg/i.test(ua)) {
        browser = "Chrome";
    } else if (/safari/i.test(ua) && !/chrome/i.test(ua)) {
        browser = "Safari";
    }

    return {
        deviceType,
        browser,
        operatingSystem,
        userAgent: ua
    };
}